<script lang="ts" setup>
import { portfolio } from '~/content/portfolio'
</script>

<template>
  <ui-section id="portfolio" :class="$style.portfolio" title="Портфолио">
    <ui-gallery
        galleryID="portfolio-gallery"
        :images="portfolio"
        class="grid grid-cols-1 md:grid-cols-3 gap-8 py-16"
        />
    <div data-aos="fade-up">
      <ui-button
          :class="$style.portfolio__button"
          :isExternal="true"
          :href="'https://www.instagram.com/irina_nails_zhlobin/'">
        Больше работ в инстаграме
      </ui-button>
    </div>
  </ui-section>
</template>
<style lang="scss" module>
.portfolio {
  @apply py-48;

  &__button {
    @apply mb-auto w-[20rem];
  }
}
</style>
